import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import Lozenge, { type LozengeProps } from '@atlaskit/lozenge/lozenge';

const messages = defineMessages({
	premium: {
		id: 'trial-components.lozenge.premium',
		defaultMessage: 'Premium',
		description:
			'The text is shown inside a lozenge badge used to indicate that a feature or item is available on the Premium edition. It appears next to features or UI elements that require a Premium subscription.',
	},
});

export const PremiumLozenge = ({ testId }: Pick<LozengeProps, 'testId'>): React.JSX.Element => {
	return (
		<Lozenge appearance="discovery" testId={testId}>
			<FormattedMessage {...messages.premium} />
		</Lozenge>
	);
};
